import clsx from "clsx";
import type { FunctionComponent, PropsWithChildren } from "react";

type Props = PropsWithChildren & {
	boldLabel?: boolean;
	label: string;
	buttonLabel?: string;
	onButtonClick?: () => void;
	truncate?: boolean;
};

const DetailsListItem: FunctionComponent<Props> = ({
	boldLabel = false,
	children,
	label,
	truncate=true
}) => {
	return <>
		<dt className={clsx("text-sm leading-6 text-gray-900", boldLabel ? "font-bold" : "font-medium")}>{label}</dt>
		<dd className={clsx(" text-sm leading-6 text-gray-700", truncate ? "truncate" : "")}>{children}</dd>
	</>;
};

export default DetailsListItem;